import { render, staticRenderFns } from "./my-point.vue?vue&type=template&id=592c990e"
import script from "./my-point.vue?vue&type=script&lang=js"
export * from "./my-point.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports